export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-time-line',
      title: 'Gain de temps immédiat',
      description: 'Récupérez jusqu\'à 15 heures par semaine pour vous concentrer sur la stratégie',
      metric: '+15h',
      metricLabel: 'par semaine'
    },
    {
      icon: 'ri-mental-health-line',
      title: 'Réduction de la charge mentale',
      description: 'Déléguez la gestion opérationnelle et libérez votre esprit pour l\'innovation',
      metric: '-70%',
      metricLabel: 'de stress'
    },
    {
      icon: 'ri-24-hours-line',
      title: 'Disponibilité 24/7',
      description: 'Votre assistant travaille pendant que vous dormez, aucune opportunité manquée',
      metric: '24/7',
      metricLabel: 'actif'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Scalabilité sans recrutement',
      description: 'Augmentez votre capacité opérationnelle sans les coûts d\'embauche',
      metric: 'x3',
      metricLabel: 'capacité'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'ROI rapide et mesurable',
      description: 'Retour sur investissement dès le premier mois avec des KPIs précis',
      metric: '&lt;30j',
      metricLabel: 'ROI positif'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Sécurité et confidentialité',
      description: 'Données chiffrées, conformité RGPD, hébergement sécurisé en Europe',
      metric: '100%',
      metricLabel: 'confidentiel'
    }
  ];

  return (
    <section id="benefices" className="py-24 px-6 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-600/5 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-violet-600/10 border border-violet-500/30 rounded-full mb-6">
            <span className="text-sm text-violet-300 whitespace-nowrap">Bénéfices Business</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Des résultats concrets,
            <br />
            <span className="bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">
              mesurables dès le premier jour
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-sm border border-white/10 rounded-xl p-8 hover:border-violet-500/50 transition-all group cursor-pointer"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-violet-600/20 to-blue-600/20 rounded-lg group-hover:scale-110 transition-transform">
                  <i className={`${benefit.icon} text-2xl text-violet-400`}></i>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent" dangerouslySetInnerHTML={{ __html: benefit.metric }}></div>
                  <div className="text-xs text-gray-400 whitespace-nowrap">{benefit.metricLabel}</div>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-3">{benefit.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-violet-600/10 to-blue-600/10 border border-violet-500/30 rounded-2xl px-8 py-6">
            <p className="text-2xl md:text-3xl font-bold">
              Un assistant. Une disponibilité totale.
              <br />
              <span className="bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">
                Une exécution sans faille.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}